import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useTestId from '@ori/testid-generator';
import { Badge, styled } from '@ori-ui/mui';
import { memo } from 'react';
import { LiveStreamingStates, LiveStreamingStateWrapTestIds } from "../../../models";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NowLiveStreamingRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: 999,
    boxShadow: "0px 0px 0 2px ".concat(theme.palette.red[300]),
    position: 'relative'
  };
});
var NowLiveStreamingText = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.palette.red[300],
    fontSize: theme.typography.pxToRem(5),
    color: theme.palette.common.white,
    padding: theme.spacing(0, 0.8),
    borderRadius: '3px',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: theme.spacing(-1)
  };
});
var badgeSize = 2;
var StyledBadge = styled(Badge)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.red[300],
      color: theme.palette.red[300],
      width: theme.spacing(badgeSize),
      minWidth: theme.spacing(badgeSize),
      height: theme.spacing(badgeSize),
      padding: 0,
      border: 0,
      margin: theme.spacing(7 / 5),
      // Somehow disabling invisible via props is not working
      '&.MuiBadge-invisible': {
        transform: 'translate(50%, -50%)'
      }
    }
  };
});
export var LiveStreamingStateWrap = /*#__PURE__*/memo(function (_ref4) {
  var children = _ref4.children,
    streamingActivity = _ref4.streamingActivity;
  var _useTestId = useTestId(),
    getTestIdProps = _useTestId.getTestIdProps;
  if (streamingActivity === LiveStreamingStates.WAS_LIVE || streamingActivity === LiveStreamingStates.PLANNED) {
    return /*#__PURE__*/_jsx(StyledBadge, _objectSpread(_objectSpread({
      invisible: true
    }, getTestIdProps(LiveStreamingStateWrapTestIds.AVATAR_BADGE_WAS_LIVE)), {}, {
      children: children
    }));
  }
  if (streamingActivity === LiveStreamingStates.IS_LIVE) {
    return /*#__PURE__*/_jsxs(NowLiveStreamingRoot, _objectSpread(_objectSpread({}, getTestIdProps(LiveStreamingStateWrapTestIds.AVATAR_BADGE_IS_LIVE)), {}, {
      children: [children, /*#__PURE__*/_jsx(NowLiveStreamingText, {
        children: "LIVE"
      })]
    }));
  }
  return children;
});